var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as Types from './types';
import { prepareDocumentDataStep } from '../../components/StepImage/documentDataReview';
var initialState = {
    form: {
        countSteps: 0,
        steps: [],
    },
};
var reducer = function (state, action) {
    var _a, _b, _c, _d, _e, _f;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Types.SET_DOCUMENT_DATA_REVIEW:
            return __assign(__assign({}, state), { documentDataReview: action.documentDataReview });
        case Types.SET_PROGRESS_FORM:
            return action.form ? __assign(__assign({}, state), { progressForm: action.form }) : state;
        case Types.SET_FORM:
            if (action.form) {
                return __assign(__assign({}, state), { form: action.form });
            }
            break;
        case Types.ADD_FORM_STEP:
            if (action.form) {
                var prepared_1 = prepareDocumentDataStep(action.form, state.documentDataReview);
                var steps = __spreadArray(__spreadArray([], state.form.steps.filter(function (existing) { return !prepared_1.form.steps.some(function (next) { return next.stepName === existing.stepName; }); }), true), prepared_1.form.steps, true);
                steps = steps.sort(function (a, b) { return a.step - b.step; });
                return __assign(__assign({}, state), { documentDataReview: prepared_1.review, form: __assign(__assign({}, state.form), { steps: steps }) });
            }
            break;
        case Types.SET_FORM_INFO:
            return __assign(__assign({}, state), { progressForm: ((_a = state.formInfo) === null || _a === void 0 ? void 0 : _a.tokenOnboarding) === ((_b = action.formInfo) === null || _b === void 0 ? void 0 : _b.tokenOnboarding)
                    && ((_c = state.formInfo) === null || _c === void 0 ? void 0 : _c.productName) === ((_d = action.formInfo) === null || _d === void 0 ? void 0 : _d.productName) ? state.progressForm : undefined, documentDataReview: ((_e = state.formInfo) === null || _e === void 0 ? void 0 : _e.tokenOnboarding) === ((_f = action.formInfo) === null || _f === void 0 ? void 0 : _f.tokenOnboarding)
                    ? state.documentDataReview : undefined, formInfo: action.formInfo });
        case Types.RESET_FORM_STATE:
            return initialState;
    }
    return state;
};
export default reducer;
